module.exports = __webpack_public_path__ + "static/allrecrings-b62a7b8971380bb59f9a479a5edb23c6.jpeg";